import { ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";

interface ModalOverlayProps {
  children: ReactNode;
  panelClassName?: string;
}

const ModalOverlay = ({ children, panelClassName }: ModalOverlayProps) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted) return null;

  const modalContent = (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden bg-black/50 p-3 sm:p-4">
      <div
        className={`flex max-h-[calc(100dvh-1.5rem)] w-full flex-col overflow-hidden rounded-lg bg-white shadow-xl sm:max-h-[calc(100dvh-2rem)] ${panelClassName ?? "max-w-2xl"}`}
      >
        {children}
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default ModalOverlay;
